<template>
    <div class="archive-users-container">
        <PreLoader v-if="isLoading"/>
        <div class="header-title" v-html="$t('archivedUsers')"/>
        <div class="select-type" style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
            <v-select outlined dense :label="$t('chooseRole')" :items="roles" item-text="title"
                      item-value="role" v-model="archiveRole" @change="changeRole"/>
<!--            <v-pagination v-model="currentPage" :length="totalPages" :total-visible="10"></v-pagination>-->
<!--            <span>{{ paginationPageText }}</span>-->
        </div>
        <div class="table-content" v-if="archiveStudents.length">
            <SmartTable :current-page="currentPage" :page-size="pageSize" :schools="archiveStudents"
                        :total-elements="totalElements" :totalPages="totalPages" menu="Students"  @leftClick="onLeftClick" @rightClick="onRightClick">

                <template v-slot:head>
                    <!--                  <th class="top-th"><input v-model="isSelectAll" type="checkbox" @click="selectAll"></th>-->
                    <th>№</th>
                    <th>{{ $t('full_name') }}</th>
                    <th>{{ $t('class') }}</th>
                    <th>{{ $t('birthDate') }}</th>
                    <th></th>
                </template>

                <template v-slot:body="{ item }">
                    <!--                  <td><input v-model="item.checked" type="checkbox" v-show="isSelectAll"></td>-->
                    <td>{{1 }}</td>
                    <td>{{ item.surname +' '+ item.name }}</td>
                    <td>{{ item.classTitle }}</td>
                    <td>{{ formatDOB(item.dateOfBirth) }}</td>
                    <td>
                        <button class="activate" @click="activateStudent(true, item)">
                            {{$t('activate')}}
                        </button>
                    </td>
                </template>

            </SmartTable>
<!--            <table class="table bordered">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                    <th>№</th>-->
<!--                    <th>{{ $t('full_name') }}</th>-->
<!--                    <th>{{ $t('class') }}</th>-->
<!--                    <th>{{ $t('birthDate') }}</th>-->
<!--                    <th></th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr v-for="(student, i) in archiveStudents" :key="student.id">-->
<!--                    <td>{{ i + 1 }}</td>-->
<!--                    <td>{{ student.surname +' '+ student.name }}</td>-->
<!--                    <td>{{ student.classTitle }}</td>-->
<!--                    <td>{{ formatDOB(student.dateOfBirth) }}</td>-->
<!--                    <td>-->
<!--                        <button class="activate" @click="activateStudent(true, student)">-->
<!--                            {{$t('activate')}}-->
<!--                        </button>-->
<!--                    </td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--            </table>-->
        </div>

        <!--ACTIVATE MODAL-->
        <v-dialog v-model="activateModal" name="activate-modal" height="auto">
            <div class="modal-container">
                <h4 v-html=" $t('activateStudent')"/>
                <div class="btn-actions">
                    <v-btn color="red" @click="toggleActivateModal">{{ $t('cancel') }}</v-btn>
                    <v-btn color="green" @click="activateStudent(false)">{{$t('activate')}}</v-btn>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import { StudentService } from '@/_services/student.service'
import PreLoader from '@/components/preloader/PreLoader'
import moment from 'moment'
import SmartTable from '@/components/table/SmartTable.vue'
const studentService = new StudentService()

export default {
  components: {
    SmartTable,
    PreLoader
  },
  data () {
    return {
      isLoading: false,
      activateModal: false,
      archiveRole: '',
      selectedStudent: {},
      currentPage: 1,
      totalPages: 0,
      totalElements: 0,
      pageSize: 0,
      archiveStudents: [],
      archiveTeachers: [],
      roles: []
    }
  },

  // watch: {
  //   currentPage (val) {
  //     if (val === 0) this.fetchArchiveStudents(val)
  //     else this.fetchArchiveStudents(val - 1)
  //   }
  // },
  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    },
    paginationPageText () {
      return this.$t('paginationPageText', [this.totalElements, this.currentPage, this.totalPages])
    }
  },
  mounted () {
    this.archiveRole = 'student'
    this.changeRole(this.archiveRole)
    this.roles = [
      { title: this.$t('archiveStudent'), role: 'student' }
    ]
  },
  methods: {
    changeRole (role) {
      if (role === 'student') {
        this.fetchArchiveStudents(0)
      }
    },

    formatDOB (date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },

    onLeftClick () {
      this.currentPage--
      this.fetchArchiveStudents(true, this.currentPage - 1)
    },

    onRightClick () {
      this.currentPage++
      this.fetchArchiveStudents(true, this.currentPage - 1)
    },

    fetchArchiveStudents (page) {
      this.isLoading = true
      studentService.getAllBySchool(this.school.id, '', true, page, 10, 0).then((res) => {
        this.archiveStudents = res.content
        this.totalPages = res.totalPages
        this.totalElements = res.totalElements
        this.pageSize = res.pageSize
        this.currentPage = res.number + 1
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    toggleActivateModal () {
      this.activateModal = false
      // this.$modal.toggle('activate-modal')
    },

    activateStudent (confirm, student) {
      if (confirm) {
        this.selectedStudent = student
        this.activateModal = true
        // this.toggleActivateModal()
      } else {
        this.isLoading = true
        studentService.activate(this.selectedStudent.id).then(() => {
          this.changeRole(this.archiveRole)
          this.toggleActivateModal()
          this.$toast.success(this.$t('successfullyActivated'))
        }).catch((err) => {
          this.$toast.error(err)
          this.isLoading = false
        })
      }
    }
  }

}
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
    .header-title {
        font-size: 20px !important;
        width: 100%;
        text-align: center;
    }
    .archive-users-container {
        padding: 10px!important;
    }
    .select-type{
        width: 100%;
        max-width: none!important;
    }
    .v-select-item{
        width: 100%;
    }
}
.select-type{
    max-width: 300px;
}
.header-title {
    margin-bottom: 15px;
    font-size: 28px;
    font-weight: bold;
}
th, td {
    vertical-align: middle;
}
  .archive-users-container {
    //margin: 20px 20px 60px 20px;
      padding: 10px 30px;
    .activate {
      font-size: 14px;
      color: #fff;
      border-radius: 4px;
        padding: 4px 16px;
      //margin: 6px auto;
      //width: 155px;
      cursor: pointer;
      background: #4caf50;
    }
    .table-content {
      table {
        font-weight: bold;
      }
    }
  }
</style>
